import { Decimal, splitIntoBoxes, type DecimalInput } from '@app/shared';
import { useTranslation } from 'react-i18next';
import { formatQty } from '@/shared/lib/money';

export interface BoxQtyProps {
  quantity: DecimalInput;
  unitsPerBox: DecimalInput | null | undefined;
  unit?: string;
  className?: string;
}

/** Renders a base-unit quantity as a box breakdown ("8 коробок + 4 шт"), derived on the fly from
 *  the product's `unitsPerBox` — never persisted, so it can't drift if the packaging changes. */
export function BoxQty({ quantity, unitsPerBox, unit, className }: BoxQtyProps) {
  const { t } = useTranslation('common');

  if (unitsPerBox === null || unitsPerBox === undefined) return <>—</>;
  if (!new Decimal(unitsPerBox).greaterThan(0)) return <>—</>;

  let breakdown;
  try {
    breakdown = splitIntoBoxes(quantity, unitsPerBox);
  } catch {
    return <>—</>;
  }

  const boxesLabel = t('qty.boxesCount', { count: breakdown.boxes });
  const remainderLabel = breakdown.remainder.isZero() ? null : formatQty(breakdown.remainder, unit);

  return (
    <span className={className ? `tabular-nums ${className}` : 'tabular-nums'}>
      {remainderLabel ? `${boxesLabel} + ${remainderLabel}` : boxesLabel}
    </span>
  );
}
